import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { RemoteConfigService } from '../../services/remote-config.service';

@Component({
    selector: 'app-show-thumb',
    templateUrl: './show-thumb.component.html',
    styleUrls: ['./show-thumb.component.scss']
})
export class ShowThumbComponent implements OnInit, AfterViewInit {

    @Input() item: any;
    @Input() dpadStart = false;
    @Output() focused = new EventEmitter<void>();

    routerLink: string[];

    constructor(private router: Router,
                public config: RemoteConfigService) {
    }

    ngOnInit(): void {
        this.routerLink = this.getRouterLink();
    }

    ngAfterViewInit(): void {

    }

    getRouterLink(): string[] {
        if (this.item.nav && this.item.nav !== 'standard') {
            return ['/' + this.item.nav];
        }

        if (this.item.slug === 'Latest Videos') {
            return ['/latest-videos'];
        }
        if (this.item.seasonId) {
            return ['/season', this.item.seasonId];
        }
        return ['/shows', this.item.slug];
    }

    redirectToPage() {
        this.router.navigate(this.getRouterLink());
    }

}
